import { BaseBookingModel, ServiceBookingModel } from '../models'

export function isServiceBookingModel(booking: BaseBookingModel): booking is ServiceBookingModel {
  return !!(booking as ServiceBookingModel).employee
}
